var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"loader-svg",attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('ellipse',{staticClass:"loader-ellipse",attrs:{"cx":"12","cy":"12","rx":"10","ry":"10"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }